import * as Yup from 'yup';

import { ValidationErrorMessages } from '@constants/forms';

const validationSchema = Yup.object({
  appointmentCode: Yup.string()
    .required(ValidationErrorMessages.FIELD_REQUIRED)
    .length(6, ValidationErrorMessages.INVALID_APPOINTMENT_CODE),
});

export type JoinSectionValues = Yup.InferType<typeof validationSchema>;

export { validationSchema };
